// extracted by mini-css-extract-plugin
export default {"wrapper":"ExternalQuestionnaireUrlDialog_wrapper__yE8Bj","urlNotice":"ExternalQuestionnaireUrlDialog_urlNotice__F7Vla"};